import UserBookings from "../../components/booking/UserBookings.tsx";

function UserBookingsPage() {
  return <UserBookings />;
}

export default UserBookingsPage;
